import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

import { AuthService } from '../login/auth.service';

@Component({
  selector: 'app-magic-login',
  templateUrl: './magic-login.component.html',
  styleUrls: ['./magic-login.component.scss'],
})
export class MagicLoginComponent implements OnInit, OnDestroy {
  public state: 'loading' | 'error' = 'loading';
  public errorMessage = '';

  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (!token) {
      this.showError('Nedostaje token u poveznici. Provjerite link iz e-maila.');
      return;
    }
    this.authService
      .magicLinkLogin(token)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (candidateId: number) => {
          if (candidateId) {
            this.router.navigate(['/candidate/applications', candidateId]);
          } else {
            this.router.navigate(['/candidate']);
          }
        },
        error: (err: HttpErrorResponse) => {
          const backendMsg = err?.error?.error || err?.error?.message;
          this.showError(backendMsg || 'Prijava nije uspjela. Link je mozda istekao ili je vec iskoristen.');
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public goToLogin(): void {
    this.router.navigate(['/candidate-login']);
  }

  private showError(message: string): void {
    this.state = 'error';
    this.errorMessage = message;
  }
}
